jQuery(document).ready(function($) {
    const membershipSlider = $('.membership__options');
    
    if (membershipSlider.length === 0) {
        return;
    }

    const options = membershipSlider.find('.membership__option');
    
    if (options.length === 0) {
        return;
    }

    let carousel = null;
    let needsSlider = false;

    function checkIfSliderNeeded() {
        // Temporarily remove flickity if active to measure natural widths
        const wasActive = !!carousel;
        if (carousel) {
            membershipSlider.flickity('destroy');
            carousel = null;
            // Small delay to let DOM settle
            setTimeout(function() {
                performCheck();
            }, 50);
            return;
        }
        
        performCheck();
        
        function performCheck() {
            const wrapper = membershipSlider.closest('.membership__wrapper');
            const wrapperWidth = wrapper.length > 0 ? wrapper.innerWidth() : $(window).width();
            
            // Measure actual total width of all cards in their natural flex layout
            // This accounts for max-width: 350px, gaps, and actual rendered sizes
            let totalWidth = 0;
            
            options.each(function() {
                const $card = $(this);
                // Get the actual outer width including margins
                totalWidth += $card.outerWidth(true);
            });
            
            // Check if we need slider (with small buffer for rounding/padding)
            needsSlider = totalWidth > wrapperWidth - 20; // 20px buffer for rounding
            
            if (needsSlider && !wasActive) {
                initSlider();
            } else if (!needsSlider && wasActive) {
                destroySlider();
            } else if (needsSlider && wasActive) {
                // Reinitialize if still needed
                initSlider();
            }
            
            updateFadeStates();
        }
    }

    function calculateGradientWidth() {
        const wrapper = membershipSlider.closest('.membership__wrapper');
        
        if (wrapper.length === 0) return;
        
        const viewportWidth = $(window).width();
        const wrapperRect = wrapper[0].getBoundingClientRect();
        
        // Calculate the space from viewport edge to wrapper edge (divided by 2 since wrapper is centered)
        const gradientWidth = Math.max(0, (viewportWidth - wrapperRect.width) / 2);
        
        // Set CSS variable on the wrapper
        wrapper[0].style.setProperty('--gradient-width', gradientWidth + 'px');
    }

    function initSlider() {
        const wrapper = membershipSlider.closest('.membership__wrapper');
        
        // Remove no-slider class if present
        membershipSlider.removeClass('no-slider');
        wrapper.addClass('has-slider');
        
        // Calculate and set gradient width
        calculateGradientWidth();
        
        carousel = membershipSlider.flickity({
            cellSelector: '.membership__option',
            prevNextButtons: false,
            autoPlay: false,
            pauseAutoPlayOnHover: false,
            wrapAround: false,
            pageDots: true,
            cellAlign: 'left',
            contain: true, // Contain within bounds
            freeScroll: false,
            groupCells: false,
            adaptiveHeight: false
        });
        

        // Handle navigation buttons
        $('.membership__nav-button--previous').on('click', function() {
            if (carousel) {
                carousel.flickity('previous');
            }
        });

        $('.membership__nav-button--next').on('click', function() {
            if (carousel) {
                const flickityData = membershipSlider.data('flickity');
                if (flickityData) {
                    const wrapperWidth = wrapper.innerWidth();
                    const lastSlide = flickityData.slides[flickityData.slides.length - 1];
                    const lastSlideRight = lastSlide.target + $(lastSlide.cell).outerWidth(true);
                    
                    // If last card already fits, don't scroll further
                    if (lastSlideRight <= wrapperWidth) {
                        return;
                    }
                }
                carousel.flickity('next');
            }
        });

        // Update button states and fade on select
        membershipSlider.on('select.flickity', function() {
            updateButtonStates();
            updateFadeStates();
        });

        // Update on settle
        membershipSlider.on('settle.flickity', function() {
            updateButtonStates();
            updateFadeStates();
        });

        updateButtonStates();
        updateFadeStates();
    }

    function destroySlider() {
        const wrapper = membershipSlider.closest('.membership__wrapper');
        
        if (carousel) {
            membershipSlider.flickity('destroy');
            carousel = null;
        }
        membershipSlider.addClass('no-slider');
        wrapper.removeClass('has-slider is-start is-end');
        updateFadeStates();
    }

    function updateButtonStates() {
        if (!carousel) return;
        
        const flickityData = membershipSlider.data('flickity');
        if (!flickityData) return;

        const isStart = flickityData.selectedIndex === 0;
        const isEnd = flickityData.selectedIndex >= flickityData.slides.length - 1;

        $('.membership__nav-button--previous').prop('disabled', isStart);
        $('.membership__nav-button--next').prop('disabled', isEnd);
    }


    function updateFadeStates() {
        const wrapper = membershipSlider.closest('.membership__wrapper');
        
        if (!carousel) {
            membershipSlider.removeClass('is-start is-end');
            wrapper.removeClass('is-start is-end');
            return;
        }

        const flickityData = membershipSlider.data('flickity');
        if (!flickityData) return;

        // Check if we're at the start
        const isStart = flickityData.selectedIndex === 0;
        
        // Check if we're at the end (last card fits in wrapper)
        const wrapperWidth = wrapper.innerWidth();
        const lastSlide = flickityData.slides[flickityData.slides.length - 1];
        if (lastSlide) {
            const lastSlideRight = lastSlide.target + $(lastSlide.cell).outerWidth(true);
            const isEnd = lastSlideRight <= wrapperWidth || flickityData.selectedIndex >= flickityData.slides.length - 1;
            
            membershipSlider.toggleClass('is-start', isStart);
            membershipSlider.toggleClass('is-end', isEnd);
            wrapper.toggleClass('is-start', isStart);
            wrapper.toggleClass('is-end', isEnd);
        }
    }

    // Initial check
    checkIfSliderNeeded();

    // Check on resize with debounce
    let resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            // Recalculate gradient width if slider is active
            if (carousel) {
                calculateGradientWidth();
            }
            checkIfSliderNeeded();
        }, 250);
    });
});

